import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { TooltipWrapper } from 'modules/experiments/components/ui';
import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { updateExperimentLocale } from 'modules/experiments/takeover/ducks/actions';
import { getTakeoverExperimentLocale } from 'modules/experiments/takeover/ducks/selectors';
import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const ExperimentLocaleSwitcher = () => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const currentLocale = useSelector(getTakeoverExperimentLocale);
  const { locale, setLocale } = useQueryParamContext();
  const { isLoading } = useLocaleSettingsContext();
  const {
    reFetch: { variantList: refetchVariantList },
    unsavedChanges: { variantList: hasUnsavedVariant },
  } = useTakeoverExperimentContext();
  const isFirstRender = useRef(true);

  /**
   * Sync up the locale selected in the
   * locale switcher with our redux store
   * */
  useEffect(() => {
    dispatch(updateExperimentLocale(locale));
  }, [locale]);

  /**
   * Sync up the locale saved in the redux store
   * to our query param context. So, that the locale
   * switcher would use this as the selected locale
   * */
  useEffect(() => {
    setLocale(currentLocale);

    // On the first load we would have already loaded the variant
    // content with the right locale. So, we can skip the reFetch call
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // re-fetch the variant list as the selected locale changes
    refetchVariantList();
  }, [currentLocale]);

  if (isLoading) return null;

  return (
    <TooltipWrapper
      tooltipContent={hasUnsavedVariant ? t('takeover.header.tooltip.localeSwitcher') : null}
    >
      <LocaleSwitcher isReadOnly={true} isSwitcherDisabled={hasUnsavedVariant} />
    </TooltipWrapper>
  );
};
